import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Landing() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleJoinAsGuest = () => {
    navigate('/aljk23');
  };

  const handleRegister = () => {
    navigate('/auth');
  };

  const handleLogin = () => {
    navigate('/auth');
  };

  const handleGetStarted = () => {
    navigate('/auth');
  };

  return (
    <div className="landing-page">
      <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
        <div className="navbar-container">
          <div className="navbar-logo">
            <i className="fas fa-video"></i>
            <span>Nxtmeet</span>
          </div>
          <div className="navbar-links">
            <a href="#features">Features</a>
            <a href="#how-it-works">How It Works</a>
            <a href="#why-choose-us">Why Us</a>
            <button className="btn-secondary" onClick={handleLogin}>Login</button>
            <button className="btn-primary" onClick={handleGetStarted}>Get Started</button>
          </div>
        </div>
      </nav>

      <section className="hero-section" id="hero">
        <div className="hero-container">
          <div className="hero-content">
            <div className="trust-badge">
              <i className="fas fa-check-circle"></i>
              <span>Trusted by 100,000+ users worldwide</span>
            </div>
            <h1 className="hero-title">Connect with your loved ones</h1>
            <p className="hero-subtitle">
              Experience crystal-clear video calls that bring you closer to the people who matter most. 
              Secure, reliable, and beautifully simple video communication for everyone.
            </p>
            <div className="hero-cta">
              <button className="btn-hero-primary" onClick={handleGetStarted}>
                Start Free
                <i className="fas fa-arrow-right"></i>
              </button>
              <button className="btn-hero-secondary" onClick={handleJoinAsGuest}>
                <i className="fas fa-play-circle"></i>
                Watch Demo
              </button>
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-number">100K+</div>
                <div className="stat-label">Active Users</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">4.9/5</div>
                <div className="stat-label">User Rating</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">Uptime</div>
              </div>
            </div>
          </div>
          <div className="hero-image">
  <img
    src="/hero-illustration.png"
    alt="Video calling preview"
    className="hero-main-image"
  />
</div>

        </div>
      </section>

      <section className="features-section" id="features">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Powerful features for seamless communication</h2>
            <p className="section-subtitle">Everything you need to stay connected with crystal-clear quality</p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-video"></i>
              </div>
              <h3 className="feature-title">HD Video Quality</h3>
              <p className="feature-description">
                Experience stunning 1080p video quality with adaptive streaming that adjusts to your connection.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3 className="feature-title">End-to-End Encryption</h3>
              <p className="feature-description">
                Your conversations stay private with military-grade encryption protecting every call.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3 className="feature-title">Group Calls</h3>
              <p className="feature-description">
                Connect with up to 50 participants in crystal-clear group video calls with ease.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-desktop"></i>
              </div>
              <h3 className="feature-title">Screen Sharing</h3>
              <p className="feature-description">
                Share your screen seamlessly for presentations, collaboration, or just showing what you see.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-mobile-alt"></i>
              </div>
              <h3 className="feature-title">Cross-Platform</h3>
              <p className="feature-description">
                Works perfectly on desktop, mobile, and tablet. Start on one device, continue on another.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-clock"></i>
              </div>
              <h3 className="feature-title">No Time Limits</h3>
              <p className="feature-description">
                Enjoy unlimited call duration. Talk for as long as you want without interruptions.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="how-it-works-section" id="how-it-works">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">How it works</h2>
            <p className="section-subtitle">Get started in three simple steps</p>
          </div>
          <div className="how-it-works-content">
            <div className="how-it-works-illustration">
              <div className="illustration-placeholder">
                <div className="illustration-circle circle-1">
                  <i className="fas fa-user-plus"></i>
                </div>
                <div className="illustration-circle circle-2">
                  <i className="fas fa-link"></i>
                </div>
                <div className="illustration-circle circle-3">
                  <i className="fas fa-video"></i>
                </div>
                <div className="illustration-line line-1"></div>
                <div className="illustration-line line-2"></div>
              </div>
            </div>
            <div className="how-it-works-steps">
              <div className="step-item">
                <div className="step-number">01</div>
                <div className="step-content">
                  <h3 className="step-title">Create your account</h3>
                  <p className="step-description">
                    Sign up in seconds with your email. No credit card required, no hidden fees. 
                    Start your free account and explore all features instantly.
                  </p>
                </div>
              </div>
              <div className="step-item">
                <div className="step-number">02</div>
                <div className="step-content">
                  <h3 className="step-title">Share your link</h3>
                  <p className="step-description">
                    Generate your personal meeting link and share it with anyone. 
                    They can join directly from their browser without any downloads or installations.
                  </p>
                </div>
              </div>
              <div className="step-item">
                <div className="step-number">03</div>
                <div className="step-content">
                  <h3 className="step-title">Start connecting</h3>
                  <p className="step-description">
                    Click to join and you're live! Enjoy high-quality video calls with seamless 
                    performance across all devices. It's that simple.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose-us-section" id="why-choose-us">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Why choose Nxtmeet</h2>
            <p className="section-subtitle">The platform trusted by individuals and teams worldwide</p>
          </div>
          <div className="why-choose-grid">
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="fas fa-bolt"></i>
              </div>
              <h3 className="benefit-title">Lightning Fast</h3>
              <p className="benefit-description">
                Connect instantly with zero lag. Our optimized infrastructure ensures smooth, 
                buffer-free calls every time.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="fas fa-lock"></i>
              </div>
              <h3 className="benefit-title">Secure & Private</h3>
              <p className="benefit-description">
                Bank-level security with end-to-end encryption. Your data never touches our servers, 
                keeping your conversations truly private.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="fas fa-heart"></i>
              </div>
              <h3 className="benefit-title">User-Friendly</h3>
              <p className="benefit-description">
                Intuitive design that anyone can use. No technical knowledge required—just click and connect.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="fas fa-headset"></i>
              </div>
              <h3 className="benefit-title">24/7 Support</h3>
              <p className="benefit-description">
                Our dedicated support team is always here to help. Get answers whenever you need them.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="fas fa-globe"></i>
              </div>
              <h3 className="benefit-title">Global Reach</h3>
              <p className="benefit-description">
                Connect with anyone, anywhere. Our worldwide server network ensures reliable calls across continents.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="fas fa-dollar-sign"></i>
              </div>
              <h3 className="benefit-title">Free Forever</h3>
              <p className="benefit-description">
                Core features always free. Upgrade only when you need advanced capabilities for your team.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to transform your communication?</h2>
            <p className="cta-subtitle">
              Join thousands of users who have already discovered a better way to connect. 
              Start your free account today and experience the difference.
            </p>
            <div className="cta-buttons">
              <button className="btn-cta-primary" onClick={handleGetStarted}>
                Get Started Free
                <i className="fas fa-arrow-right"></i>
              </button>
              <button className="btn-cta-secondary" onClick={handleRegister}>
                Create Account
              </button>
            </div>
            <p className="cta-note">No credit card required • Free forever • Cancel anytime</p>
          </div>
        </div>
        <footer className="footer">
          <div className="footer-content">
            <div className="footer-left">
              <div className="footer-logo">
                <i className="fas fa-video"></i>
                <span>Nxtmeet</span>
              </div>
              <p className="footer-tagline">Bringing people together, one call at a time</p>
            </div>
            <div className="footer-links">
              <div className="footer-column">
                <h4>Product</h4>
                <a href="#features">Features</a>
                <a href="#how-it-works">How It Works</a>
                <a href="#why-choose-us">Why Choose Us</a>
              </div>
              <div className="footer-column">
                <h4>Company</h4>
                <a href="#about">About Us</a>
                <a href="#careers">Careers</a>
                <a href="#contact">Contact</a>
              </div>
              <div className="footer-column">
                <h4>Resources</h4>
                <a href="#help">Help Center</a>
                <a href="#privacy">Privacy Policy</a>
                <a href="#terms">Terms of Service</a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Nxtmeet. All rights reserved.</p>
          </div>
        </footer>
      </section>
    </div>
  );
}

export default Landing;